<template>
  <div id="plan-billing">
    <v-dialog v-model="payment.dialog" max-width="600px">
      <v-card v-if="payment.plan.purchasable" class="rounded-xl" elevation="7">
        <v-card-title>
          <span class="text-h5">Upgrading to {{ payment.plan.name }}</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6">
                <v-select
                  v-model="payment.type"
                  :items="payment.paymentOptions"
                  :outlined="!$store.state.site.whitelabel"
                  item-text="name"
                  item-value="internalName"
                  label="Pay with:"
                ></v-select>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <p>
              This will cost
              {{
                calculateCost(payment.plan.price).toLocaleString("en-US", {
                  style: "currency",
                  currency: "USD"
                })
              }}.
            </p>
            <p v-if="payment.type === 'credits'">
              You currently have
              {{
                calculateCost($store.state.user.credits).toLocaleString(
                  "en-US",
                  { style: "currency", currency: "USD" }
                )
              }}
              in credits.
            </p>
            <p v-if="payment.type === 'credits'">
              You can buy more credits in User Settings.
            </p>
            <p
              v-if="
                payment.type === 'credits' &&
                $store.state.user.credits < payment.plan.price
              "
              style="color: #cc2a2a"
            >
              You do not have enough credits to complete this transaction.
            </p>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="rounded-xl"
            color="blue darken-1"
            text
            @click="dialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            class="rounded-xl"
            :loading="payment.loading"
            color="blue darken-1"
            text
            @click="upgrade()"
          >
            Upgrade
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-container>
      <div v-if="!loading">
        <v-container>
          <v-card-title class="text-h3 justify-center"> Plans</v-card-title>
          <v-row>
            <v-col v-for="plan in plans" :key="plan.id">
              <v-card class="rounded-xl" elevation="7">
                <v-container class="text-center">
                  <p
                    :style="'color:' + plan.color"
                    class="justify-center text-h4"
                  >
                    {{ plan.name }}
                  </p>
                  <p class="justify-center text-h6">
                    {{
                      calculateCost(plan.price).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD"
                      })
                    }}
                    per month
                  </p>
                  <p
                    v-for="feature in JSON.parse(plan.features)"
                    :key="feature"
                  >
                    {{ feature }}
                  </p>
                  <v-btn
                    class="rounded-xl"
                    v-if="$store.state.user.plan.id !== plan.id"
                    color="info"
                    @click="initUpgrade(plan)"
                    >Upgrade
                  </v-btn>
                  <v-btn
                    class="rounded-xl"
                    v-if="$store.state.user.plan.id === plan.id"
                    color="info"
                    disabled
                    >Current Plan
                  </v-btn>
                </v-container>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </div>
      <v-card v-if="loading" class="rounded-xl" elevation="7">
        <v-container class="text-center">
          <p class="text-lg-h4">Loading...</p>
        </v-container>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import AjaxErrorHandler from "@/lib/errorHandler"

export default {
  name: "Plans",
  data() {
    return {
      plans: [],
      loading: true,
      payment: {
        loading: false,
        dialog: false,
        plan: [],
        type: "credits",
        paymentOptions: [
          {
            name: "Jays.host Credits",
            internalName: "credits"
          }
        ]
      }
    }
  },
  methods: {
    upgrade() {
      this.payment.loading = true
      this.axios
        .post("/api/v1/billing/upgrade/" + this.payment.plan.id)
        .then(() => {
          this.axios
            .get("/api/v1/userutils/info")
            .then((res) => {
              this.$store.commit("login", res.data)
              this.payment.loading = false
              this.payment.dialog = false
              this.$toast("Thank you for purchasing a plan.", {
                timeout: 3000,
                type: "success"
              })
            })
            .catch((e) => {
              AjaxErrorHandler(this.$store)(e)
            })
        })
        .catch((e) => {
          this.payment.loading = false
          AjaxErrorHandler(this.$store)(e)
        })
    },
    initUpgrade(plan) {
      this.payment.plan = plan
      this.payment.dialog = true
    },
    calculateCost(price) {
      return price / 100
    },
    getPlans() {
      this.loading = true
      this.axios
        .get("/api/v1/billing/plans")
        .then((res) => {
          this.loading = false
          this.plans = res.data
        })
        .catch((e) => {
          AjaxErrorHandler(this.$store)(e)
        })
    }
  },
  mounted() {
    this.getPlans()
  }
}
</script>

<style scoped></style>
